import { render, staticRenderFns } from "./BillOfLoading.vue?vue&type=template&id=df2d1aac&scoped=true"
import script from "./BillOfLoading.vue?vue&type=script&lang=js"
export * from "./BillOfLoading.vue?vue&type=script&lang=js"
import style0 from "./BillOfLoading.vue?vue&type=style&index=0&id=df2d1aac&prod&scoped=true&lang=scss"
import style1 from "./BillOfLoading.vue?vue&type=style&index=1&id=df2d1aac&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df2d1aac",
  null
  
)

export default component.exports